import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";
import Popup from './Popup.js';
import FontKeys from '../../FontKeys.js';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class SideUI extends AContainer 
{
    constructor(scene)
    {
        super(scene);

        this.scene = scene;

        this.createMainBtns();

        this.tweenInUI();
    }

    createMainBtns()
    {
        this.doneBtn = this.scene.add.container(this.scene.mid.x*2 - 90, this.scene.mid.y*2 - 170);
        this.doneBtnBG = this.scene.addButton(0, 0, "Btn_Done", null, ()=>{
            this.scene.playSound("click");
            this.scene.removeTools();
            this.scene.pauseGame();
            this.popup = new Popup(this.scene, "done");
        }, this.doneBtn);
        const doneTxt = ABCyaPhaser.Text.addText(0, this.doneBtnBG.height/2 - 5, 38, 0xFFFFFF, FontKeys.din_alternatebold, gameData.maskLocalization.getLocalizedString("buttonNames.done", gameData.maskLocalization.isDefault), this.doneBtn, true).setResolution(1.5).setWordWrapWidth(100).setLineSpacing(-4);

        this.resetBtn = this.scene.addButton(this.scene.mid.x*2 - 215, this.scene.mid.y*2 - 90, "Btn_New", null, ()=>{
            this.scene.playSound("click");
            this.scene.removeTools();
            this.scene.pauseGame();
            this.popup = new Popup(this.scene, "reset");
        }, this.scene);

        this.menuBtn = this.scene.addButton(this.scene.mid.x*2 - 55, this.scene.mid.y*2 - 260, "Btn_Menu", null, ()=>{
            this.scene.playSound("click");
            this.scene.removeTools();
            this.scene.pauseGame();
            this.popup = new Popup(this.scene, "menu");
        }, this.scene);

        this.toggleBtns(false);
        this.doneBtn.setScale(0, 0);
        this.resetBtn.setScale(0, 0);
        this.menuBtn.setScale(0, 0);
    }

    toggleBtns(onOff)
    {
        this.doneBtnBG.setEnabled(onOff);
        this.resetBtn.setEnabled(onOff);
        this.menuBtn.setEnabled(onOff);
    }

    tweenInCursor(color)
    {
        let dot = this.dots[gameData.dotColors.indexOf(color)];
        this.cursor.x = dot.x;
        this.cursor.y = dot.y + dot.height/2;
        this.cursor.setScale(0, 0);
        if(this.type === "trim") this.cursor.tint = "0xf2b640";
        else if(this.type === "bg") this.cursor.tint = "0x3bccba";

        this.scene.killTween(this.cursor);
        this.scene.addTween(this.cursor, 500, {scaleX:1, scaleY:1}, Phaser.Math.Easing.Back.Out);
    }

    tweenOutCursor()
    {
        this.scene.killTween(this.cursor);
        this.scene.addTween(this.cursor, 100, {scaleX:0, scaleY:0}, Phaser.Math.Easing.None);
    }

    tweenInUI()
    {
        this.scene.addTween(this.doneBtn, 500, {scaleX:1, scaleY:1}, Phaser.Math.Easing.Back.Out);
        this.scene.addTween(this.resetBtn, 500, {scaleX:1, scaleY:1, delay:50}, Phaser.Math.Easing.Back.Out);
        this.scene.addTween(this.menuBtn, 500, {scaleX:1, scaleY:1, delay:100}, Phaser.Math.Easing.Back.Out,
            ()=>{this.toggleBtns(true);});
    }

    tweenOutUI()
    {
        this.toggleBtns(false);
        this.scene.addTween(this.doneBtn, 500, {scaleX:0, scaleY:0}, Phaser.Math.Easing.Back.In);
        this.scene.addTween(this.resetBtn, 500, {scaleX:0, scaleY:0, delay:50}, Phaser.Math.Easing.Back.In);
        this.scene.addTween(this.menuBtn, 500, {scaleX:0, scaleY:0, delay:100}, Phaser.Math.Easing.Back.In);
    }

    cleanUp()
    {
        this.toggleBtns(false);

        this.doneBtn.destroy();
        this.resetBtn.destroy();
        this.menuBtn.destroy();

        if(this.popup){
            this.popup.cleanUp();
            this.popup.destroy();
        }
    }
}